'use strict';

(function ($, FUNCTIONS) {
	var a = 'is-active';
	var v = 'is-visible';
	var slideSpeed = '400';

	// ＜ルート設定対応＞要素が空だったら削除
	var removeElmIfEmpty = function removeElmIfEmpty() {
		$('.js-checkEmptyElm').each(function (idx, val) {
			if (!$(val).text().length) {
				$(val).remove();
			}
		});
	};
	// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
	var removeBlockIfListEmpty = function removeBlockIfListEmpty() {
		if ($('.js-checkEmptyList').length) {
			$('.js-checkEmptyList').each(function (idx, val) {
				if (!$(val).find('li').length) {
					$(val).parents('.js-checkEmptyList-wrap').remove();
				}
			});
		}
	};

	//モーダル
	var modalImg = function modalImg() {
		$('.mod-modal').on('click', function (e) {
			var HTML = '<div class="mod-modal-overlay">';
			HTML += '<div class="mod-modal-closeArea"></div>' + '<span class="mod-modal-closeBtn"><span class="mod-modal-closeBtn-inner"></span></span>' + ($(e.currentTarget).find('img').prop('outerHTML') + '</div>');
			$('body').append(HTML);

			var $overlay = $('.mod-modal-overlay');
			$overlay.addClass('is-active');
			setTimeout(function () {
				$overlay.addClass('is-visible');

				$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', function () {
					$overlay.removeClass('is-visible');
					setTimeout(function () {
						$overlay.removeClass('is-active');
						$overlay.remove();
					}, 400);
				});
			});
		});
	};
	var modalVideo = function modalVideo() {
		$('.mod-modal_video').on('click', function (e) {
			// console.log($(e.target),$(e.currentTarget).data('video'));
			var HTML = '<div class="mod-modal_video-overlay">';
			HTML += '<div class="mod-modal_video-closeArea"></div>' + '<span class="mod-modal_video-closeBtn"><span class="mod-modal_video-closeBtn-inner"></span></span>' + '<div class="_video"><div class="mod-youtube"><iframe width="560" height="315" src="https://www.youtube.com/embed/' + $(e.currentTarget).data('video') + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div></div>';
			$('body').append(HTML);

			var $overlay = $('.mod-modal_video-overlay');
			$overlay.addClass('is-active');
			setTimeout(function () {
				$overlay.addClass('is-visible');

				$('.mod-modal_video-closeArea, .mod-modal_video-closeBtn').on('click', function () {
					$overlay.removeClass('is-visible');
					setTimeout(function () {
						$overlay.removeClass('is-active');
						$overlay.remove();
					}, 400);
				});
			});
		});
	};
	var animation = function animation() {
		// 文字背景アニメーション
		if ($('.js-text-anime').length) {
			$('.js-text-anime').waypoint(function (direction) {
				var activePoint = $(this.element);
				if (direction === 'down') {
					//scroll down
					activePoint.addClass(a);
				} else {
					//scroll up
					activePoint.removeClass(a);
				}
			}, { offset: '70%' });
		}
	};

	removeElmIfEmpty();
	removeBlockIfListEmpty();
	modalImg();
	modalVideo();
	animation();
})(window.jQuery, window.FUNCTIONS);